import { GTM } from "./../../utilities/GTM";
import Cookies from "js-cookie";

const GTMEventName = "ITS.modal"; // GTM dataLayer event name

export class ModalComponent {
    public static SELECTOR = ".modal";
    public static BACKGROUND_SELECTOR = ".modal__background";
    public static WRAPPER_SELECTOR = ".modal__wrapper";
    public static CLOSE_MODAL_SELECTOR = "[data-close-modal]";
    public static TOGGLE_MODAL_CLASS = "is--open";
    public static TOGGLE_BODY_CLASS = "overflow--hidden";

    public static autoInit(): ModalComponent[] {
        const modals = document.querySelectorAll(this.SELECTOR) as NodeListOf<HTMLElement>;
        return Array.from(modals).map((modal) => new this(modal));
    }

    protected modalElement: HTMLElement;
    protected modalWrapperElement: HTMLElement;
    protected modalCloseButtonElements: NodeListOf<HTMLElement>;
    protected modalToggables: NodeListOf<HTMLElement>;
    protected tempEventListener: EventListener;
    protected tempNavigationEventListener: EventListener;
    protected autoOpen: boolean = false;
    protected disableBackground: boolean = false;

    constructor(modal: HTMLElement) {
        this.modalElement = modal;

        const autoOpen = this.modalElement.dataset.modalAutoOpen as string;
        if (autoOpen === "true") {
            this.autoOpen = true;
        }

        const disableBackground = this.modalElement.dataset.disableBackground as string;
        if (disableBackground === "true") {
            this.disableBackground = true;
        }

        const modalName = this.modalElement.dataset.modal as string;
        this.modalWrapperElement = this.modalElement.querySelector(
            ModalComponent.WRAPPER_SELECTOR,
        ) as HTMLElement;
        this.modalCloseButtonElements = this.modalElement.querySelectorAll(ModalComponent.CLOSE_MODAL_SELECTOR);
        this.modalToggables = document.querySelectorAll(`[data-target-modal="${modalName}"]`);

        this.addEventListeners();

        if (this.autoOpen) {
            this.open();
        }
    }

    // Black background element
    private get backgroundElement(): HTMLElement {
        return document.querySelector(ModalComponent.BACKGROUND_SELECTOR) as HTMLElement;
    }

    // Click event for opening modal
    protected onClickOpen(e: Event): void {
        e.preventDefault();
        this.open();
    }

    // Click event for closing modal
    protected onClickClose(e: Event): void {
        e.preventDefault();
        this.close();
    }

    // CLose modal when clicking outside
    protected onContainerClick(e: Event): void {
        if (e.target === this.modalElement) {
            this.close();
        }
    }

    // Open modal
    protected open(): void {
        this.modalElement.classList.add(ModalComponent.TOGGLE_MODAL_CLASS);
        this.backgroundElement.classList.add(ModalComponent.TOGGLE_MODAL_CLASS);
        document.body.classList.add(ModalComponent.TOGGLE_BODY_CLASS);

        if (!this.disableBackground) {
            this.tempEventListener = this.closeOnEscape.bind(this);
            document.addEventListener("keydown", this.tempEventListener);
            const mobileNav = document.querySelector(".navigation-md__head");
            if (mobileNav instanceof HTMLElement) {
                mobileNav.classList.add("not--main");
                this.tempNavigationEventListener = this.onClickClose.bind(this);
                mobileNav.addEventListener("click", this.tempNavigationEventListener);
            }
        }
        GTM.send({
            event: GTMEventName,
            action: "open",
        });
    }

    // Close modal
    protected close(): void {
        this.modalElement.classList.remove(ModalComponent.TOGGLE_MODAL_CLASS);
        this.backgroundElement.classList.remove(ModalComponent.TOGGLE_MODAL_CLASS);
        document.body.classList.remove(ModalComponent.TOGGLE_BODY_CLASS);

        document.removeEventListener("keydown", this.tempEventListener);
        const mobileNav = document.querySelector(".navigation-md__head");
        if (mobileNav instanceof HTMLElement) {
            mobileNav.classList.remove("not--main");
            mobileNav.removeEventListener("click", this.tempNavigationEventListener);
        }
        GTM.send({
            event: GTMEventName,
            action: "close",
        });
        const isBanner = (this.modalElement.dataset.modalIsBanner as string) === "true";
        if (isBanner) {
            Cookies.set(
                "banner-shown",
                1,
                {
                    expires: 1,
                },
            );
        }
    }

    // Close modal when escape key is pressed
    protected closeOnEscape(e: KeyboardEvent) {
        if (e.key === "Escape" || e.key === "Esc" || e.keyCode === 27) {
            e.preventDefault();
            this.close();
        }
    }

    // Event listeners
    private addEventListeners(): void {
        Array.from(this.modalToggables).forEach((toggable) => {
            toggable.dataset.initialized = "true";
            toggable.addEventListener("click", this.onClickOpen.bind(this));
        });

        Array.from(this.modalCloseButtonElements).forEach((closeButton) => {
            closeButton.addEventListener("click", this.onClickClose.bind(this));
        });

        if (!this.disableBackground) {
            this.modalElement.addEventListener("click", this.onContainerClick.bind(this));
        }

        document.addEventListener("DOMChanged", () => {
            const modalName = this.modalElement.dataset.modal as string;
            const modalToggables = document.querySelectorAll(
                `[data-target-modal="${modalName}"]`,
            ) as NodeListOf<HTMLElement>;

            Array.from(modalToggables).forEach((toggable) => {
                if (toggable.dataset.initialized === "true") {
                    return;
                }
                toggable.dataset.initialized = "true";
                toggable.addEventListener("click", this.onClickOpen.bind(this));
            });
        });
    }
}



// WEBPACK FOOTER //
// ./components/modal/modal.component.ts